import React from 'react';
import { graphql } from "gatsby"

import Pancake from "./Pancake";
import Container from "../Container";
import PancakeIntro from "../PancakeIntro";
import Tabs from "../Tabs"
import Person from "../Person"

import "./Team.scss";

const TeamPancake = props => {

  const { title, text, employees, investors, theme } = props;

  return (
    <Pancake className="TeamPancake" theme={theme}>
      <Container>
        <PancakeIntro title={title} text={text} />
        <div className="TeamPancakeGrid">
          {employees?.map(employee => <div className="PersonCard"><Person person={employee}  key={employee.name} /></div>)}
        </div>
        {/* <Tabs>
          <Tabs.Tab label="Team">
            <div className="TeamPancakeGrid">
              {employees?.map(employee => <Person person={employee}  key={employee.name} />)}
            </div>
          </Tabs.Tab>
          <Tabs.Tab label="Advisors">
            <div className="TeamPancakeGrid">
              {investors?.map(investor => <Person person={investor} key={investor.name} />)}
            </div>
          </Tabs.Tab>
        </Tabs> */}
      </Container>
    </Pancake>
  );
}

export const query = graphql`
  fragment SanityTeamPancake on SanityTeam {
    _key
    _type
    pancakeIntro {
      pancakeTitle
      pancakeText
    }
    investors {
      name
      twitter
      linkedin
      jobtitle
      headline
      company {
        name
      }
      _id
      image {
        ...ImageWithPreview
      }
    }
    employees {
      name
      twitter
      linkedin
      jobtitle
      headline
      team
      _id
      image {
        ...ImageWithPreview
      }
    }
    theme
  }
`

export default TeamPancake;